import { render, staticRenderFns } from "./PropertyInfoPanel.global.vue?vue&type=template&id=0ce28cfa&scoped=true&lang=pug&"
import script from "./PropertyInfoPanel.global.vue?vue&type=script&lang=ts&"
export * from "./PropertyInfoPanel.global.vue?vue&type=script&lang=ts&"
import style0 from "./PropertyInfoPanel.global.vue?vue&type=style&index=0&id=0ce28cfa&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ce28cfa",
  null
  
)

export default component.exports